/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "../../../../default/global/js/utilities/updateClasses";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "../../../../default/global/js/iconbarHover";
import {initToggleSlide} from "../../../../default/global/js/toggle";
import {XhrService} from "../../../../default/global/ts/xhr.service";
import {appendScriptToDOM} from "../../../../default/global/js/utilities/functions";
import {initFormSubmitChanges} from "../../../../default/global/js/actionClick";
import {closeModal, showModal} from "../../../../default/global/js/modal";
import {initInputBody} from "../../../../default/global/js/inputfile";
import {focusInputGroups} from "../../../../default/global/js/checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "../../../../default/global/js/itemlistStickyOrderBar";
import {getAllQuantityInputs} from "../../../../default/global/js/quantitySpinner";
import {setAccessibilityLiveRegionMessage} from "../../../../default/global/js/accessibilityLiveRegionService";
import {initCustomization, checkValidDLRGCustomization} from "../custom/customization";

function updateHeaderBasket(doc,showHeaderBasket = true) {
    let delayBasketHover = 6000;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (const headerBasket of document.querySelectorAll('.js-headerBasket')) {
        const newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            const basketCount = headerBasket.querySelector('.js-basketCount');
            const itemBasketBoxes = doc.querySelectorAll(".itemBasketBox");

            if(!itemBasketBoxes){
                showHeaderBasket = false;
            }else{
                if (basketCount) {
                    addActionClass(basketCount);
                }
                if(showHeaderBasket){
                    headerBasket.classList.add("showIconbarHover");
                    showIconbarHover(headerBasket);
                    initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));

                    setTimeout(function () {
                        hideIconbarHover(headerBasket);
                    }, delayBasketHover);
                }
            }
        }
    }
}

function dispatchCustomUpdateBasketViewsEvent(data,name="updateBasketViews"){
    document.dispatchEvent(new CustomEvent(name, {
        detail: { data }
    }));
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    for (const quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        const form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    for (const spDiscount of basketView.querySelectorAll('.js-itemBasketList .spDiscount input[type="number"]')) {
        const form = spDiscount.closest(".js-itemBasketList");
        spDiscount.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        spDiscount.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }

}

function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    for (const spinner of basketView.querySelectorAll('.js-itemBasketList .quantity .js-spinnerUp,.js-itemBasketList .quantity .js-spinnerDown')) {
        const form = spinner.closest(".js-itemBasketList");
        spinner.addEventListener("click", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    }
}

function updateAllBasketViews(basketView, newBasketView) {
    if (basketView && newBasketView) {
        const oldList = basketView.querySelector('.js-itemBasketList');
        const oldOrderBox = basketView.querySelector('.js-basketOrderBox');
        const oldSummary = basketView.querySelector('.js-basketSummary');
        const oldBasketPaymentButtons = basketView.querySelector('.js-basketPaymentButtons');

        const newList = newBasketView.querySelector('.js-itemBasketList');
        const newOrderBox = newBasketView.querySelector('.js-basketOrderBox');
        const newSummary = newBasketView.querySelector('.js-basketSummary');
        const newBasketPaymentButtons = newBasketView.querySelector('.js-basketPaymentButtons');

        setAccessibilityLiveRegionMessage(GLOBALS.tc.refreshedBasket);

        if (newList) {
            oldList.innerHTML = newList.innerHTML;
            removeLoadingClass(oldList);
            eventListenerBasketViewQuantities(basketView);
            eventListenerBasketViewQuantitySpinners(basketView);
            eventListenerBasketViewSpDiscounts(basketView);
        } else {
            basketView.innerHTML = newBasketView.innerHTML;
            return;
        }

        if (newOrderBox) {
            oldOrderBox.innerHTML = newOrderBox.innerHTML;
            removeLoadingClass(oldOrderBox);
            initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
            initFormSubmitChanges();
        }
        if (newSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
        }

        if (newBasketPaymentButtons) {
            oldBasketPaymentButtons.innerHTML = newBasketPaymentButtons.innerHTML;
            executeScripts(oldBasketPaymentButtons);
        }
    }
}

function executeScripts(element) {
    const scripts = element.querySelectorAll('script');

    scripts.forEach(script => {
        const newScript = document.createElement('script');
        newScript.src = script.src;
        document.head.appendChild(newScript);
        newScript.remove();
    });
}

function sendBasketForm(form, basketView) {
    const formData = new FormData(form);
    addLoadingClass(basketView.querySelector('.js-itemBasketList'));
    addLoadingClass(basketView.querySelector('.js-basketOrderBox'));
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'));

            dispatchCustomUpdateBasketViewsEvent({
                data
            });

            console.log('Success:', data);
        })
        .catch((e) => {
            console.error('Error:', e);
        });
}


export function triggerBasketBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".basketSpoilerLabel")) {
            const label = target.closest(".basketSpoilerLabel");
            const spoiler = label.nextElementSibling;
            if (spoiler && spoiler.classList.contains("basketSpoiler")) {
                const isVisible = spoiler.style.display !== "none";
                spoiler.style.display = isVisible ? "none" : "";
                const icon = label.querySelector("i[class*=icon-angle]");
                if (icon) {
                    icon.classList.toggle("icon-angle-down", isVisible);
                    icon.classList.toggle("icon-angle-up", !isVisible);
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");
            const form = target.closest("form");
            const orderButtonWrapper = target.closest(".orderButtonWrapper");
            const quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');

            if (form && quantityInput) {
                if (quantityInput.value > 0) {
                    addLoadingClass(target);
                    target.ariaBusy="true";
                    const formData = new FormData(form);
                    const action = form.dataset.action;
                    formData.set('action', action);
                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket && response.headerBasketContent) {
                            const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                            updateHeaderBasket(doc);
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        return response.status;
                    })
                        .catch((e) => {
                            target.ariaBusy="false";
                            addErrorClass(target);
                            console.error('Error:', e);
                            console.error('Action:', form.action);
                            console.error(formData);
                        }).finally(()=>{
                        updateItemlistStickyOrderBarCount();
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        addSuccessClass(target);
                        target.ariaBusy="false";
                    });
                }

            }
            e.preventDefault();
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            const form = target.closest("form");
            const orderButtonWrapper = target.closest(".orderButtonWrapper");
            const quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            const customizableInputValue = form.dataset.customized;
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue === '1') || target.classList.contains("js-addToBasketItemcardCustomization"))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1' || target.classList.contains("js-addToBasketItemcardCustomization")) {
                    addLoadingClass(target);
                    let fn = 'cart';
                    const formData = new FormData(form);
                    const action = form.dataset.action;
                    let isValid = true;
                    formData.set('action', action);
                    if (customizableInputValue === '1') {
                        fn = 'cartCustomize';
                    }

                    if(target.classList.contains("js-addToBasketItemcardCustomization")){
                        isValid = checkValidDLRGCustomization(form);
                        if(!isValid){
                            removeLoadingClass(target);
                            e.preventDefault();
                            return;
                        }
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        addSuccessClass(target);
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        if (fn === 'cartCustomize') {
                            const existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                                initCustomization(customizeModal);
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            if (headerBasket && response.headerBasketContent) {
                                const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            const existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                        });
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasket")) {
            target = target.closest(".js-removeFromBasket");

            const basketView = document.getElementById("userBasket");

            const formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);

            addLoadingClass(target);

            if(basketView){
                fetch("?action=shop_remove_item_from_basket", {
                    method: "POST",
                    body: formData,
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw "Could not save data";
                        }
                        return response.text();
                    })
                    .then((data) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, "text/html");
                        if(doc.querySelector(".itemBasketList")){
                            updateAllBasketViews(basketView, doc.getElementById('userBasket'));
                            updateHeaderBasket(doc,false);
                        }else{
                            location.reload();
                        }

                        dispatchCustomUpdateBasketViewsEvent({
                            data
                        });
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }else{
                formData.set('action', target.dataset.action);

                XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    addSuccessClass(target);
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }
            e.preventDefault();
        }

        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            const form = target.closest("form");
            if (!checkValidDLRGCustomization(form)) {
                e.preventDefault();
                return;
            }

            addLoadingClass(target);

            const formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                const customizationData = response.inputDataArray;
                Object.keys(customizationData).forEach(key => {
                    const cleanKey = key.replace("input", "");
                    const customizationText = document.getElementById(cleanKey);
                    customizationText.innerHTML = customizationData[key];
                });
                form.reset();
                const existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
            .catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
            });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");

            const formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);
            formData.set('user_basket_id', target.dataset.userbasketid);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);

                const itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    const existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    const customizeModal = response.customizeModal;
                    const newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                    initCustomization(document.getElementById("modalUserQueue"));
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");
            const quantityInputs = getAllQuantityInputs();
            const forms = new Set();

            for(const qty of quantityInputs){
                const form = qty.closest("form");
                if(form){
                    forms.add(form);
                }
            }

            if (forms) {
                const formDatas = new FormData();
                for(const form of forms){
                    const qtyInput = form.querySelector('.quantity input[type="number"]');
                    if(qtyInput){
                        if(parseInt(qtyInput.value) > 0){
                            const formData = new FormData(form);
                            for (const pair of formData.entries()) {
                                formDatas.append(pair[0], pair[1]);
                            }
                        }
                    }
                }
                addLoadingClass(target);
                formDatas.set('action', 'shop_add_all_items_to_basket');

                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    for(const form of forms){
                        form.reset();
                    }
                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                        console.error(formDatas);
                    });

            }
            e.preventDefault();
        }
    });
}

export function triggerUpdateBasketView() {
    const updateTimeout = false;
    const basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);

        new CustomEvent('updateBasketViews', {
            detail: { message: 'Die Funktion wurde erfolgreich ausgeführt!' }
        });
    }
}

